import { UserInputValidationFailedModelBase } from "./UserInputValidationFailedModel.base"


/* A graphql query fragment builders for UserInputValidationFailedModel */
export { selectFromUserInputValidationFailed, userInputValidationFailedModelPrimitives, UserInputValidationFailedModelSelector } from "./UserInputValidationFailedModel.base"

/**
 * UserInputValidationFailedModel
 */
export const UserInputValidationFailedModel = UserInputValidationFailedModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
